import React, { useEffect } from 'react';
import withRouter from 'src/config/withRouter';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { db } from '../../../config/firebase'; // firebase
import moment from 'moment'
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import makeStyles from '@mui/styles/makeStyles';
import { FavoriteBorderOutlined } from '@mui/icons-material';
import { Rating } from '@mui/material';
// imags
import ageIcon from '../../../assets/images/ageIcon.svg';
import genderIcon from '../../../assets/images/genderIcon.svg';
// components
import { calculateRating } from '../../../config/RatingCalculation';

const useStyles = makeStyles(theme=> ({
    card:props=>({
        width: props.width ? props.width : '46%',
        height:'auto',
        borderRadius:'10px',
        backgroundColor:'#fff',
        display:'flex',
        flexDirection:'column',
        boxShadow: '0 2px 7px gainsboro',
        cursor:'pointer',
        marginBottom:'20px',
        [theme.breakpoints.down('sm')]:{
            width:'100%'
        },
    }),

    photoDiv:{
        width:'100%',
        position:'relative',
        height:'130px',
        borderTopRightRadius:'10px',
        borderTopLeftRadius:'10px',
        '& img':{
            width:'100%',
            height:'100%',
            borderTopRightRadius:'10px',
            borderTopLeftRadius:'10px',
        }
    },

    cardStyle:{
        width:'350px',
        height:'auto',
        borderRadius:'10px',
        backgroundColor:'#fff',
        display:'flex',
        flexDirection:'column',
        boxShadow: '0 2px 7px gainsboro',
        cursor:'pointer',
        marginBottom:'10px',
        [theme.breakpoints.down('sm')]:{
            width:'250px'
        },
    },

    marLeft:{
        marginLeft:'20px',
        [theme.breakpoints.between('xs','md')]: {
            marginLeft:'0px'
        }
    },
    marRight:{
        marginRight:'20px',
        [theme.breakpoints.between('xs','md')]: {
            marginRight:'0px'
        }
    },

    marLeft2:{
        marginLeft:'20px',
    },
    marRight2:{
        marginRight:'20px',
    },

    marAR:{
        margin:'0px auto',
        [theme.breakpoints.between('xs','md')]: {
            marginLeft:'0px'
        }
    },
    
    marLeft_2:{
        marginLeft:'10px'
    },
    marRight_2:{
        marginRight:'10px'
    },

    photoStyle:{
        width:'350px',
        position:'relative',
        height:'130px',
        borderTopRightRadius:'10px',
        borderTopLeftRadius:'10px',
        [theme.breakpoints.down('sm')]:{
            width:'250px'
        },
        '& img':{
            width:'100%',
            height:'100%',
            borderTopRightRadius:'10px',
            borderTopLeftRadius:'10px',
        }
    },

    activityName:props=>({
        fontSize:'14px',
        color: props.fontDarkColor ? props.fontDarkColor : '#000',
        fontWeight:'bold',
        fontFamily: "'Cairo', sans-serif",
    }),

    publishDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        backgroundColor:'#fff',
        width:'70%',
        "& svg":{
            fontSize:'1em'
        }
    },

    ratingText:{
        color:'#000',
        fontSize:'11px',
        paddingLeft:'5px',
    },

    infoDiv:{
        display:'flex',
        flexDirection:'column',
        width:'calc(100% - 20px)',
        padding:'0px 10px'
    },

    ratingDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        padding:'2px 0px'
    },

    ageDiv:{
        justifyContent:'flex-start'
    },

    genderDiv:{
        justifyContent:'flex-start'
    },

    ageText:{
        color:'#000',
        fontSize:'11px',
        textTransform:'capitalize'
    },

    onlineDiv:{
        position:'absolute',
        top:'5px',
        right:'41px',
        width:'55px',
        height:'20px',
        backgroundColor:'#0AB8E5',
        cursor:'pointer',
        color:'#fff',
        fontSize:'12px',
        textAlign:'center',
        lineHeight:'19px'
    },

    favIcon:{
        position:'absolute',
        top:0,
        right:'10px',
        color:'#fff',
        fontSize:'1.9em'
    },

    rootStarLeft:{
        textAlign:'left',
        fontSize:'1rem'
    },
    rootStarRight:{
        fontSize:'1rem',
        textAlign:'right'
    }
}));

// Activity card template
function ActivityCard(props) {
    const isMounted = React.useRef(null);
    const [reviews, setReviews] = React.useState([]);
    const { t, i18n, cover, name, rating, ageFrom, ageTo, gender, fromActivity, fontDarkColor,history, serviceId,width, online, imgCustomClass, cardCustomClass } = props;
    const classes = useStyles({fontDarkColor,width});

    useEffect(() => {
        isMounted.current = true;
        function getReviews(){ // get current service all reviews
            if(serviceId) {
                db.ref(`Reviews`).orderByChild('serviceId').equalTo(serviceId).once('value',(data)=> {
                    const reviewData = data.val();
                    let array = [];
                    if(reviewData) {
                        for(const val in reviewData) {
                            array.push(reviewData[val])
                        }
                        if(isMounted.current) setReviews(array);
                    }
                })
                .catch(e=> {
                    console.log('error',e.message)
                })
            }
        }
        
        getReviews();
        return () => isMounted.current = false;
    }, [serviceId]);

    const redirectEvent = () => {
        if(serviceId) history.push(`/activity/${serviceId}`);
    }
    
    const isRTL = i18n.translator.language;
    moment.locale(isRTL);
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en; 
    const cardClass = clsx({
        [classes.card]: !fromActivity,
        [cardCustomClass ? cardCustomClass : classes.cardStyle]: fromActivity,
    });
    const photoClass = clsx({
        [classes.photoDiv]: !fromActivity,
        [imgCustomClass ? imgCustomClass : classes.photoStyle]: fromActivity,
    });
    const productMarginARClass = clsx({
        [cardCustomClass ? classes.marLeft2 : classes.marLeft]: !width,
        [classes.marAR]: width,
    });
    const productMarginENClass = clsx({
        [cardCustomClass ? classes.marRight2 : classes.marRight]: !width,
        [classes.marAR]: width,
    });
    return(
        <div dir={isRTL === 'ar' ? 'rtl' : 'ltr'} className={`${cardClass} ${isRTL === 'ar' ? productMarginARClass : productMarginENClass}`} onClick={redirectEvent}>
            {/* photoDiv */}
            <div className={photoClass}>
                {online ? <div className={classes.onlineDiv} style={{fontFamily}}>{t('companyPage.online')}</div> : null }
                <ImgLazyLoad>
                    <img alt={name} src={cover} style={{objectFit:'cover'}}/>
                </ImgLazyLoad>
            </div>

            {/* publish status */}
            <div className={classes.infoDiv}>
                <span className={classes.activityName} style={{fontFamily:"'Cairo', sans-serif"}}>{name}</span>
                <div className={classes.ratingDiv}>
                    <div className={classes.publishDiv}>
                        <Rating name="half-rating-read" classes={{root: isRTL === 'ar' ? classes.rootStarRight : classes.rootStarLeft}} value={reviews.length > 0 ? calculateRating(reviews) : 0} precision={0.1} readOnly />
                        <span className={classes.ratingText} style={{fontFamily}}>{t('service.review', {count:reviews.length})}</span>
                    </div>
                </div>
                <div className={classes.ratingDiv} style={{justifyContent:'flex-start'}}>
                    {ageFrom && ageTo ?
                    <div className={`${classes.ratingDiv} ${classes.ageDiv}`}>
                        <ImgLazyLoad>
                            <img src={ageIcon} alt='age' />
                        </ImgLazyLoad>
                        <span className={`${classes.ageText} ${isRTL === 'ar' ? classes.marRight_2 : classes.marLeft_2}`} style={{fontFamily}}>{t('companyPage.age', {ageFrom:ageFrom, ageTo:ageTo})}</span>
                    </div>
                    : null}
                    {gender && gender !== '---' ?
                    <div className={`${classes.ratingDiv} ${classes.genderDiv} ${isRTL === 'ar' ? classes.marRight_2 : classes.marLeft_2}`}>
                        <ImgLazyLoad>
                            <img src={genderIcon} alt='age' />
                        </ImgLazyLoad>
                        <span className={`${classes.ageText} ${isRTL === 'ar' ? classes.marRight_2 : classes.marLeft_2}`} style={{fontFamily}}>{gender}</span>
                    </div>
                    : null}
                </div>
            </div>
        </div>
    )
}

export default withRouter(withTranslation('common')(ActivityCard));